var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.8896 26.1528C15.8386 26.1528 15.0129 25.3271 15.0129 24.2762V15.944C15.0129 14.8931 15.8386 14.0674 16.8896 14.0674C17.9405 14.0674 18.7662 14.8931 18.7662 15.944V24.2762C18.7662 25.2895 17.9405 26.1528 16.8896 26.1528Z",
    fill: "#00A551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.8896 12.7913C17.926 12.7913 18.7662 11.9511 18.7662 10.9147C18.7662 9.87827 17.926 9.03809 16.8896 9.03809C15.8531 9.03809 15.0129 9.87827 15.0129 10.9147C15.0129 11.9511 15.8531 12.7913 16.8896 12.7913Z",
    fill: "#00A551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.8895 34.4851C7.58152 34.4851 0 26.9036 0 17.5956C0 8.28758 7.58152 0.706055 16.8895 0.706055C26.1975 0.706055 33.7791 8.28758 33.7791 17.5956C33.7791 26.9036 26.1975 34.4851 16.8895 34.4851ZM16.8895 4.45928C9.6458 4.45928 3.75323 10.3519 3.75323 17.5956C3.75323 24.8393 9.6458 30.7319 16.8895 30.7319C24.1333 30.7319 30.0258 24.8393 30.0258 17.5956C30.0258 10.3519 24.1333 4.45928 16.8895 4.45928Z",
    fill: "#00A551"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.ff4141df7c1b7d767f2e7c11af48fc51.svg";
export { ForwardRef as ReactComponent };